import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export type ValidationSchemaAdministrationRequestApproveForm = {
  employees: Array<{ employeeId: string; employeeFullName: string }>;
  reason: string;
};
export const useValidationSchemaAdministrationRequestApprove = () => {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => {
    return Yup.object<ValidationSchemaAdministrationRequestApproveForm>().shape({
      employees: Yup.array()
        .of(
          Yup.object()
            .shape({
              employeeId: Yup.string().required(t('errors.requiredField')),
              employeeFullName: Yup.string(),
            })
            .test('not-unique', t('errors.employeeAlreadyExist'), function (employee, { parent: formEmployees }) {
              const currentEmployeeId = employee?.employeeId;

              if (currentEmployeeId) {
                const formEmployeeIds = formEmployees?.map(({ employeeId }) => employeeId);
                const currentEmployeeIdDuplicates = formEmployeeIds?.filter((id) => id === currentEmployeeId);

                if (currentEmployeeIdDuplicates.length > 1) {
                  const lastEmployeeDuplicate = formEmployeeIds?.findLastIndex((id) => id === currentEmployeeId);

                  return this.createError({
                    message: t('errors.employeeAlreadyExist'),
                    path: `employees.${lastEmployeeDuplicate}.employeeId`,
                  });
                }
              }

              return true;
            }),
        )
        .min(1, t('errors.requiredField'))
        .required(t('errors.requiredField')),
    });
  }, [t]);

  return { validationSchema };
};
